export default "__VITE_ASSET__DIp4Mph9__"